/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PatchApiV1NotificationMobileAppNotificationidCancel202,
  PatchApiV1NotificationMobileAppNotificationidCancel400,
  PatchApiV1NotificationMobileAppNotificationidCancel401,
  PatchApiV1NotificationMobileAppNotificationidCancel500,
  PatchApiV1NotificationMobileAppNotificationidCancelMutationResponse,
  PatchApiV1NotificationMobileAppNotificationidCancelPathParams,
} from "../../types/notificationMobileAppController/PatchApiV1NotificationMobileAppNotificationidCancel.ts";

export const patchApiV1NotificationMobileAppNotificationidCancelPathParamsSchema =
  z.object({
    notificationId: z.coerce.number().int(),
  }) as unknown as ToZod<PatchApiV1NotificationMobileAppNotificationidCancelPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const patchApiV1NotificationMobileAppNotificationidCancel202Schema =
  z.any() as unknown as ToZod<PatchApiV1NotificationMobileAppNotificationidCancel202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const patchApiV1NotificationMobileAppNotificationidCancel400Schema =
  z.any() as unknown as ToZod<PatchApiV1NotificationMobileAppNotificationidCancel400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const patchApiV1NotificationMobileAppNotificationidCancel401Schema =
  z.any() as unknown as ToZod<PatchApiV1NotificationMobileAppNotificationidCancel401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const patchApiV1NotificationMobileAppNotificationidCancel500Schema =
  z.any() as unknown as ToZod<PatchApiV1NotificationMobileAppNotificationidCancel500>;

export const patchApiV1NotificationMobileAppNotificationidCancelMutationResponseSchema =
  z.lazy(
    () => patchApiV1NotificationMobileAppNotificationidCancel202Schema,
  ) as unknown as ToZod<PatchApiV1NotificationMobileAppNotificationidCancelMutationResponse>;
